<template>
  <div class="col_2 w934 onsite_b task_jihua_list">
    <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无考试</h4>
    </h5>
    <dl v-for="item in lists" :key="item.id">
      <dt>
        <span class="btn_end" v-if="item.examIdFinish">已完成</span>
        <img src="@/assets/images/course_default.png" v-if="!item.faceUri || item.faceUri == ''" />
        <img :src="item.faceUri" v-if="item.faceUri && item.faceUri !== ''">
      </dt>
      <dd class="narrow">
        <h3>{{item.title}}</h3>
        <p class="red_font">合格标准：满分{{item.score}}分，{{item.passline}}分及格</p>
        <p>考试时长：{{item.time}}分钟   考题数量：{{item.cntQuestion}}题</p>
        <p>开放时间： {{ dateFormat(new Date(item.startDate), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(item.endDate), 'yyyy-MM-dd hh:mm:ss') }}</p>
        <p class="num_man">{{item.clickNumber}}人次参与</p>
        <p>可否重复考试: {{item.canDuplication == '1' ? '可以': '不可以'}}</p>
        <a class="a_detail" v-if="!item.examIdFinish || (item.examIdFinish && item.canDuplication == '1')" @click="to({id: item.id, type: '0'})" style="top: 55px; cursor: pointer;">开始考试</a>
        <a href="javascript:;" style="top: 105px; cursor: pointer;" class="a_detail" v-if="item.examIdFinish && item.examIdFinish!=''" @click="examDetail(item.examIdFinish)">答题详情</a>
      </dd>
    </dl>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 6,
          itemType: '01'
        },
        pages: 0,
        cntData: ''
      }
    },
    created () {
      this.search(this.filters)
    },
    methods: {
      dateFormat: utils.dateFormat,
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      search (filters) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData // 总数
          this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
        })
      },
      to (o) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({
          path: path + '/examReady/' + o.id + '/' + o.type
        })
      },
      goCheck (item) {
        switch (item.type) {
          case '01': {
            this.$router.push({path: '/continueEdu/courseDetail/'+ item.businessId})
            break
          }
          case '02': {
            this.$router.push({path: '/continueEdu/livePlay/'+ item.businessId})
            break
          }
          case '03': {
            this.$router.push({path: '/continueEdu/plan/'+ item.businessId})
            break
          }
        }
      },
      examDetail (examId) {
        var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
        this.$router.push({
          path: path + '/examResult/' + examId
        })
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/modules/task/myExam.vue